export const text = {
  title: 'Algo salió mal  ',
  description:
    'Ocurrió un error al cargar tu información, por favor inténtalo de nuevo',
  button: 'Volver a cargar'
};
